"use client";

import React from "react";
import { FileCheck, Settings, Cpu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const services = [{
  title: "Mieten & Kaufen",
  description: "Hochwertige Mehrwegbecher für Events jeder Größe. Ob Miete für einmalige Feste oder Kauf für den dauerhaften Einsatz – wir haben die Lösung.",
  icon: FileCheck
}, {
  title: "Reinigung & Logistik",
  description: "Professionelle Spülservice und pünktliche Lieferung direkt zum Veranstaltungsort in Kärnten. Wir kümmern uns um die komplette Abwicklung.",
  icon: Settings
}, {
  title: "Lagerung & Druck",
  description: "Sichere Einlagerung Ihrer Becherbestände und individueller Branding-Service für einen professionellen Auftritt Ihrer Marke oder Ihres Vereins.",
  icon: Cpu
}];
export default function SolucoesEmSustentabilidadeEGestao() {
  return <section data-section-id="227957" id="unser-rundum-service" className="py-24 bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-chart-1/10 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-chart-3/10 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-secondary mb-4 tracking-tight">
            Unser Rundum-Service
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Von der ersten Anfrage bis zur sauberen Rückgabe: Wir bieten Ihnen ein modulares Service-Paket für nachhaltige Veranstaltungen ohne Müllberge.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => <div key={i} data-index={i} className="group relative rounded-2xl p-px overflow-hidden transition-all duration-500 hover:-translate-y-2 shadow-sm hover:shadow-xl">
              {}
              <div className="absolute inset-0 bg-border group-hover:bg-gradient-to-br group-hover:from-chart-1 group-hover:to-chart-4 transition-all duration-500" />

              {}
              <div className="relative h-full bg-card rounded-2xl p-8 flex flex-col items-center text-center z-10">
                <div className="mb-8 p-5 rounded-full bg-accent text-chart-1 group-hover:bg-chart-1 group-hover:text-primary-foreground group-hover:scale-110 transition-all duration-500">
                  <service.icon className="w-12 h-12" strokeWidth={1.5} />
                </div>

                <h3 className="text-xl font-bold font-default text-secondary mb-4">
                  {service.title}
                </h3>

                <p className="text-muted-foreground mb-8 flex-grow leading-relaxed font-default">
                  {service.description}
                </p>

                {}
                <div className="opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-4 group-hover:translate-y-0">
                  <Button className="bg-chart-1 text-primary-foreground hover:bg-chart-1/90 rounded-full px-8 shadow-md transition-all" asChild>
                    <Link to="#">Mehr erfahren</Link>
                  </Button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}